import type { ReactNode } from 'react';
import { Tabs } from '../ui/Tabs';
import { inputCls } from '../ui/styles';
import { today } from '../../core/format/dates';
import { periods } from './salesPeriods';
import type { PeriodState } from './usePeriodParams';
type Props = {
  state: PeriodState;
  children?: ReactNode;
};

/** Periodekeuze voor Omzet en Inzicht: vaste periodes, of zelf kiezen met twee datums. */
export function PeriodBar({
  state,
  children
}: Props) {
  const {
    period,
    from,
    to,
    setPeriod,
    setCustom
  } = state;
  return <div className="mb-6 flex flex-wrap items-center gap-3" data-id="element-3702" data-mp="1af6n2blinnm7">
      <Tabs variant="pill" label="Periode" tabs={periods} value={period} onChange={setPeriod} data-id="element-3703" data-mp="1ahsvsek58960" />
      {children}
      {period === 'zelf' && <div className="flex flex-wrap items-center gap-2" data-id="element-3704" data-mp="10okev2g4pzdj">
          <label className="relative block" data-id="element-3705" data-mp="1y50ycoq6t44c">
            <span className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-[13px] text-muted" data-id="element-3706" data-mp="1y5st5xbymxtk">Van</span>
            <input type="date" value={from} max={to} onChange={e => setCustom('van', e.target.value)} className={`${inputCls} w-auto pl-12`} data-id="element-3707" data-mp="1tczmh3wxlfeu" />
          </label>
          <label className="relative block" data-id="element-3708" data-mp="30d1pddjb04j">
            <span className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-[13px] text-muted" data-id="element-3709" data-mp="33iv34t74o62">Tot</span>
            <input type="date" value={to} min={from} max={today()} onChange={e => setCustom('tot', e.target.value)} className={`${inputCls} w-auto pl-12`} data-id="element-3710" data-mp="3pgr4iyczopju" />
          </label>
        </div>}
    </div>;
}